/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:ccQuestionari
 * @restrict E
 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
 */
(function() {
  'use strict';
  var TlpsTraslocoTelepassCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    $state,
    $uibModal,
    postVenditaSrvc,
    traslocoTelepassSrvc,
    propostaSrvc
  ) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    this.postVenditaSrvc = postVenditaSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.propostaSrvc = propostaSrvc;
    this.$uibModal = $uibModal;

    this.spinner = this.postVenditaSrvc.spinner;

    this.ndg;

    var self = this;

    /*
     * -------------------------------------
     *         GESTIONE NAVIGAZIONE
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name generaTabs
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Genera le tab necessarie al processo sulla base del cliente
     *              e della pratica ricevuti
     */

    this.traslocoTelepassSrvc.generaTabs = function() {
      // Svuoto le tab
      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      self.tabs = [
        {
          step: 'DEFINIZIONE',
          label: 'label.tab.definizione',
          posizione: '1',
          statoPratica: 'INCORSO',
          stepPratica: null,
          sottoStep: [
            {
              step: 'DETTAGLIO_PRODOTTO',
              label: 'label.tab.dettaglio.prodotto',
              posizione: '1.1',
              statoPratica: 'INCORSO',
              stepPratica: 1,
              sottoStep: null
            },
            {
              step: 'DATI_AGGIUNTIVI',
              label: 'label.tab.dati.aggiuntivi',
              posizione: '1.2',
              statoPratica: 'INCORSO',
              stepPratica: 2,
              sottoStep: null
            }
          ]
        },
        // {
        //   step: 'GESTIONE_CONDIZIONI',
        //   label: 'label.tab.gestione.condizioni',
        //   posizione: '2',
        //   statoPratica: 'INCORSO',
        //   stepPratica: 3,
        //   sottoStep: null
        // },
        {
          step: 'QUESTIONARI',
          label: 'label.tab.questionari',
          posizione: '2',
          statoPratica: 'INCORSO',
          stepPratica: null,
          sottoStep: [
            {
              step: 'QUESTIONARIO_PRIVACY',
              label: 'label.tab.questionario.privacy',
              posizione: '2.1',
              statoPratica: 'INCORSO',
              stepPratica: 4,
              sottoStep: null
            }
          ]
        },
        {
          step: 'DOCUMENTI',
          label: 'label.tab.documenti',
          posizione: '3',
          statoPratica: 'CONSOLIDATA',
          stepPratica: 1,
          sottoStep: null
        }
      ];

      // Ciclo sulle macroTabs
      for (var i in self.tabs) {
        var macroStepIndex = Number(i);

        self.TAB_LIST_MACRO.push({
          index: macroStepIndex,
          title:
            self.tabs[macroStepIndex].posizione +
            ' ' +
            $scope.msg(self.tabs[macroStepIndex].label),
          url: self.getMacroStepUrl(self.tabs[macroStepIndex].step)
        });

        // Per ogni macro tab compongo l'oggetto microTab con i sottoStep
        self.TAB_LIST_MICRO[self.tabs[macroStepIndex].step] = [];

        for (var j in self.tabs[macroStepIndex].sottoStep) {
          var microStepIndex = Number(j);

          self.TAB_LIST_MICRO[self.tabs[macroStepIndex].step].push({
            index: microStepIndex,
            title:
              self.tabs[macroStepIndex].sottoStep[microStepIndex].posizione +
              ' ' +
              $scope.msg(
                self.tabs[macroStepIndex].sottoStep[microStepIndex].label
              ),
            url: self.getMicroStepUrl(
              self.tabs[macroStepIndex].sottoStep[microStepIndex].step
            )
          });
        }
      }

      // Imposto i tab attivi
      var tabMacroIndex;
      var microStepIndex;

      // // Se la pratica è già stata creato imposto lo step corretto
      if (self.traslocoTelepassSrvc.datiPratica) {
        tabMacroIndex = self.getMacroStepIndex(
          self.traslocoTelepassSrvc.datiPratica.stato,
          self.traslocoTelepassSrvc.datiPratica.step
        );
        microStepIndex = self.getMicroStepIndex(
          self.traslocoTelepassSrvc.datiPratica.stato,
          self.traslocoTelepassSrvc.datiPratica.step
        );
      } else {
        // Altrimenti assegno il primo step
        tabMacroIndex = 0;
        microStepIndex = 0;
      }

      self.currentTabMacro = self.TAB_LIST_MACRO[tabMacroIndex];

      self.currentTabMicro = {};

      for (var k in self.tabs) {
        self.currentTabMicro[self.tabs[Number(k)].step] =
          self.TAB_LIST_MICRO[self.tabs[Number(k)].step][microStepIndex];
      }
    };

    /**
     * @ngdoc method
     * @name getMacroStepUrl
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Ritorna il corretto id del template html a seconda del nome del macroStep
     */
    this.getMacroStepUrl = function(step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'GESTIONE_CONDIZIONI':
          return 'gestioneCondizioni.tmpl.html';
        case 'QUESTIONARI':
          return 'questionari.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return '';
      }
    };

    /**
     * @ngdoc method
     * @name getMicroStepUrl
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Ritorna il corretto id del template html a seconda del nome del microStep
     */
    this.getMicroStepUrl = function(step) {
      switch (step) {
        case 'DETTAGLIO_PRODOTTO':
          return 'dettaglioProdotto.tmpl.html';
        case 'DATI_AGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        case 'GESTIONE_CONDIZIONI':
          return 'gestioneCondizioni.tmpl.html';
        case 'QUESTIONARIO_PRIVACY':
          return 'questionarioPrivacy.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return '';
      }
    };

    /**
     * @ngdoc method
     * @name getMacroStepIndex
     * @methodOf cbl.cartadebito.wa:tlpsProposta
     * @description Ritorna l'indice della macrotab a seconda dello stato e step
     * della pratica. 0 - Definizione , 1 - Questionari , 2 - Carta e Pin , 3 - Documenti
     */
    this.getMacroStepIndex = function(stato, step) {
      if (stato === CONSTANTS.STATO_PRATICA.IN_CORSO) {
        switch (step) {
          // Definizione
          case 1:
          case 2:
            return 0;
          // Questionari
          case 4:
            return 1;
          default:
            return 0;
        }
      } else if (stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA) {
        // Documenti
        return 2;
      } else {
        return 0;
      }
    };

    /**
     * @ngdoc method
     * @name getMicroStepIndex
     * @methodOf cbl.cartadebito.wa:tlpsProposta
     * @description Ritorna l'indice della microtab a seconda dello stato e step
     * della pratica. I tab con index 0 sono i primi del macro.
     */
    this.getMicroStepIndex = function(stato, step) {
      if (stato === CONSTANTS.STATO_PRATICA.IN_CORSO) {
        switch (step) {
          // Dettaglio Profotto
          case 1:
          // Condizioni
          case 3:
          // Questionari
          case 4:
            return 0;
          // Dati Aggiuntivi
          case 2:
            return 1;
          default:
            return 0;
        }
      } else if (stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA) {
        // Documenti
        return 0;
      } else {
        return 0;
      }
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function(tab) {
      if (!self.traslocoTelepassSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Riporto ogni step al primo sottoStep
      for (var k in self.tabs) {
        self.currentTabMicro[self.tabs[Number(k)].step] =
          self.TAB_LIST_MICRO[self.tabs[Number(k)].step][0];
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function(currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function(currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    this.annullaPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsAnnulla.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    this.rifiutaPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRifiuta.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    this.revisionaPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRevisiona.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    this.risottomettiPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRisottometti.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    /*
     * -------------------------------------
     *         GESTIONE PRATICA
     * -------------------------------------
     */

    this.recuperaPratica = function() {
      // Se esiste la pratica recupero il dettaglio, altrimenti la creo subito
      if (self.idPratica) {
        self.traslocoTelepassSrvc
          .promiseDettaglioPraticaTrasloco(self.idPratica, self.ndg)
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response)) {
                return;
              }

              self.datiPratica = self.traslocoTelepassSrvc.datiPratica =
                response.data.result;

              self.traslocoTelepassSrvc.generaTabs();
            },
            function(reason) {
              self.messaggiFctr.processaResponse(reason);
              self.spinner.showSpinner = false;
            }
          );
      } else {
        var req = self.creaRequestCreaPratica();

        self.traslocoTelepassSrvc.promiseCreaPratica(req).then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.$stateParams.idPratica = self.idPratica =
              response.data.result.idPratica;

            self.datiPratica = self.traslocoTelepassSrvc.datiPratica =
              response.data.result;

            self.$state.go('.', { ndg: self.ndg, idPratica: self.idPratica });
            // self.traslocoTelepassSrvc.generaTabs();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.showSpinner = false;
          }
        );
      }
    };

    this.creaRequestCreaPratica = function() {
      return {
        class: 'PraticaTelepassDto',
        intestatario: {
          ndg: self.ndg
        },
        workflow: 'TRASLOCO_BRIO',
        settore: 'TELEPASS'
      };
    };

    /*
     * -------------------------------------
     *           METODI INIT
     * -------------------------------------
     */

    this.init = function() {
      self.traslocoTelepassSrvc.datiPratica = self.datiPratica = undefined;
      self.traslocoTelepassSrvc.datiCliente = self.datiCliente = undefined;
      self.traslocoTelepassSrvc.datiPratica = self.datiProdotto = undefined;

      // Se sono presenti resetto i dati relativi alle proposte allestite precedentemente
      if (self.propostaSrvc) {
        self.propostaSrvc.datiPratica = undefined;
        self.propostaSrvc.datiCliente = undefined;
        self.propostaSrvc.datiPratica = undefined;
      }

      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.

      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display:none;');
      }

      self.spinner.showSpinner = true;

      self.ndg = self.$stateParams.ndg;
      self.idPratica = self.$stateParams.idPratica;

      self.postVenditaSrvc
        .promiseRecuperaAnagrafica(self.ndg)
        .then(function(response) {
          self.datiCliente = self.traslocoTelepassSrvc.datiCliente =
            response.data.result;

          self.recuperaPratica();
        });
    };

    /*
     * -------------------------------------
     *           INIZIALIZZAZIONE
     * -------------------------------------
     */

    self.init();
  };

  TlpsTraslocoTelepassCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    '$state',
    '$uibModal',
    'TlpsPostVenditaSrvc',
    'TlpsTraslocoTelepassSrvc',
    'TlpsPropostaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoTelepass.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoTelepassCtrl = {
    bindings: {},
    controller: TlpsTraslocoTelepassCtrl,
    controllerAs: 'traslocoTelepassCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsTraslocoTelepass', TlpsTraslocoTelepassCtrl);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoTelepass.cmpt.js
// module id = 25
// module chunks = 0